import { Injectable } from '@angular/core';
import { ContentViewTypes } from '../training-page/content-view/content-view.component';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class DocTypeService {

  constructor(private domSenitizer: DomSanitizer) { }

  getMaterialContentTypes(source: any) {
    if (this.isPDF(source)) {
      source = this.getSecuritySafeUrl(source)
      return ContentViewTypes.Pdf
    } else if (this.isExcel(source)) {
      return ContentViewTypes.Excel
    } else if (this.isWordDoc(source)) {
      return ContentViewTypes.Doc
    } else if (this.isImage(source)) {
      return ContentViewTypes.Image
    } else if (this.isYouTubeUrl(source)) {
      source = this.getYTVideoId(source)
      return ContentViewTypes.YTVideo
    } else if (this.isVideo(source)) {
      return ContentViewTypes.Video
    }
    return ContentViewTypes.Unsupported
  }

  getSecuritySafeUrl(source: any) {
    return this.domSenitizer.bypassSecurityTrustResourceUrl(source);
  }

  isPDF(url: string): boolean {
    return /\.(pdf)$/i.test(url);
  }

  isVideo(url: string): boolean {
    return /\.(mp4|avi|mov|wmv|flv|mkv|webm)$/i.test(url);
  }

  isWordDoc(url: string): boolean {
    return /\.(doc|docx)$/i.test(url);
  }

  isExcel(url: string): boolean {
    return /\.(xls|xlsx)$/i.test(url);
  }

  isImage(url: string): boolean {
    return /\.(jpg|jpeg|png|gif|bmp)$/i.test(url);
  }

  isYouTubeUrl(url: string): boolean {
    const youtubeRegex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
    return youtubeRegex.test(url);
  }

  getYTVideoId(source: any) {
    const videoIdMatch = source.match(/[?&]v=([^&]+)/);
    return videoIdMatch ? videoIdMatch[1] : null;
  }
}
